import { useContext } from "react";
import { YippityUserContext } from "./YippityUserContext";

const PROMPT_USAGE_LIMIT = 5;

const useCanUsePrompt = () => {
  const { user } = useContext(YippityUserContext);

  if (!user) {
    return { usageRemaining: 0, canUse: false };
  }

  const usageRemaining = Math.max(0, PROMPT_USAGE_LIMIT - user.quizzesCreated);

  return {
    usageRemaining,
    canUse: user.subscriptionType === 1 || usageRemaining > 0,
  };
};

export default useCanUsePrompt;
